module.exports = __webpack_public_path__ + "img/logo_large_black.20af7831.svg";